export default __webpack_public_path__ + "static/media/full-retirement-sum-tablet.f69e29b5.svg";